import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import CategoryList from "@/components/feature/CategoryList";

export default function SerialPage() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryList category="serial" />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}